import React, { useState } from "react";
import ReactDOM from "react-dom";
import "./../../assets/css/modal.css";

function UpdateCompetitionModal({ competition, onClose, onUpdate }) {
  const [name, setName] = useState(competition.name);
  const [date, setDate] = useState(competition.date);

  const handleSubmit = (e) => {
    e.preventDefault();
    const updatedCompetition = {
      id: competition.id,
      name: name,
      date: date,
    };
    onUpdate(updatedCompetition);
  };

  return ReactDOM.createPortal(
    <>
      <div className="modal-overlay" onClick={onClose} />
      <div className="modal-wrapper">
        <div className="modal">
          <h2>Update Competition</h2>
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label htmlFor="name">Name:</label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="input-group">
              <label htmlFor="date">Date:</label>
              <input
                type="date"
                id="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                required
              />
            </div>
            <div className="button-group">
              <button type="submit">Update</button>
              <button type="button" onClick={onClose}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </>,
    document.body
  );
}

export default UpdateCompetitionModal;
